module.exports = __webpack_public_path__ + "static/Metrc_Monitor@2x-2a5f5b9eb06ea0282fc8ffa19bca612b.png";